export default __webpack_public_path__ + "static/media/plus-icon.6590fe41.svg";